import { VenueAdminzoneState } from "@/types/store/adminzone";
import { VenueData } from "@/types";

export const state: VenueAdminzoneState = {
  venues: [] as Array<VenueData>,
  allVenues: [] as Array<VenueData>,
}
